module.exports = __webpack_public_path__ + "img/female.6f986c51.svg";